import React from 'react';
import { HiOutlinePencilSquare, HiOutlineBuildingLibrary } from "react-icons/hi2";
import { FaGraduationCap, FaLinkedin, FaGithub } from "react-icons/fa6";
import { SiLeetcode, SiCodeforces, SiCodechef } from "react-icons/si";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UserAvatar from '../UserAvatar/UserAvatar';
import { ROUTES } from '../../constants';

const DEFAULT_COLLEGE_NAME = "Your Institute";

const PersonalInfoCard = ({ userInfo }) => {
  const { user } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const isOwnProfile = user && userInfo?._id === user?._id;

  const collegeName = (userInfo?.collegeName || DEFAULT_COLLEGE_NAME).trim();
  const branch = userInfo?.branch || "";
  const graduationYear = userInfo?.graduationYear || "";

  const SocialLink = ({ icon: Icon, link, color, bg }) => {
    if (!Icon) return null; // Safe guard

    const trimmed = typeof link === "string" ? link.trim() : "";
    const hasLink = !!trimmed;

    if (!hasLink) {
      return (
        <div
          className="w-12 h-12 flex items-center justify-center rounded-2xl bg-slate-100 border border-slate-200 text-slate-400 cursor-not-allowed"
        >
          <Icon size={22} />
        </div>
      );
    }

    return (
      <button
        type="button"
        title={trimmed}
        onClick={() => window.open(trimmed, '_blank', 'noopener,noreferrer')}
        className={`w-12 h-12 flex items-center justify-center rounded-2xl transition-all group hover:-translate-y-1 hover:shadow-lg active:scale-95 shadow-sm ${bg}`}
      >
        <span className={`${color} group-hover:scale-110 transition-transform`}>
          <Icon size={22} />
        </span>
      </button>
    );
  };

  return (
    <div className="p-6 flex flex-col items-center h-full">
      {/* Profile Header */}
      <div className="flex flex-col items-center mb-8">
        <UserAvatar
          src={userInfo?.profileImage}
          name={userInfo?.name}
          size={100}
          className="ring-2 ring-slate-100"
        />

        <div className="mt-4 text-center">
          <h1 className="font-black text-2xl text-slate-900 tracking-tight">
            {userInfo?.name || "User"}
          </h1>
        </div>

        {isOwnProfile && (
          <button
            onClick={() => navigate(ROUTES.editProfile)}
            className="mt-6 flex items-center gap-2 bg-slate-900 text-white px-8 py-3 rounded-2xl text-sm font-black hover:bg-blue-600 transition-all active:scale-95 shadow-lg shadow-blue-100"
          >
            <HiOutlinePencilSquare size={18} />
            Edit Profile
          </button>
        )}
      </div>

      {/* Academic Info */}
      <div className="w-full space-y-3 mb-8">
        {/* Institute */}
        <div className="flex items-center gap-3 p-4 bg-blue-50/50 rounded-2xl border border-blue-100/50">
          <HiOutlineBuildingLibrary className="text-blue-600" size={22} />
          <div className="min-w-0">
            <p className="text-[10px] font-black uppercase text-blue-400 tracking-widest">
              Institute
            </p>
            <p className="text-sm font-bold text-slate-700 truncate">
              {collegeName}
            </p>
          </div>
        </div>

        {/* Degree */}
        <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-2xl border border-slate-100">
          <FaGraduationCap className="text-slate-400" size={22} />
          <div className="min-w-0">
            <p className="text-[10px] font-black uppercase text-slate-400 tracking-widest">
              Degree
            </p>
            <p className="text-sm font-bold text-slate-700 truncate">
              {(branch || graduationYear) ? `${branch}${branch && graduationYear ? " • " : ""}${graduationYear}` : "—"}
            </p>
          </div>
        </div>
      </div>

      {/* Social/Coding Links */}
      {/* <div className="w-full mt-auto pt-6 border-t border-slate-100/60">
        <p className="text-[10px] font-black uppercase text-slate-400 tracking-[0.2em] mb-4 text-center">
          Social & Portfolios
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {userInfo?.linkedinLink && (
            <SocialLink icon={FaLinkedin} link={userInfo?.linkedinLink} color="text-[#0077b5]" bg="bg-[#0077b5]/10 hover:bg-[#0077b5]/20 hover:shadow-[#0077b5]/20" />
          )}

          {userInfo?.githubLink && (
            <SocialLink icon={FaGithub} link={userInfo?.githubLink} color="text-slate-800" bg="bg-slate-100 hover:bg-slate-200 hover:shadow-slate-300/50" />
          )}

          {userInfo?.leetcodeLink && (
            <SocialLink icon={SiLeetcode} link={userInfo?.leetcodeLink} color="text-[#FFA116]" bg="bg-[#FFA116]/10 hover:bg-[#FFA116]/20 hover:shadow-[#FFA116]/20" />
          )}

          {userInfo?.codeforcesLink && (
            <SocialLink icon={SiCodeforces} link={userInfo?.codeforcesLink} color="text-[#1F8ACB]" bg="bg-[#1F8ACB]/10 hover:bg-[#1F8ACB]/20 hover:shadow-[#1F8ACB]/20" />
          )}

          {userInfo?.codechefLink && (
            <SocialLink icon={SiCodechef} link={userInfo?.codechefLink} color="text-[#5B4638]" bg="bg-[#5B4638]/10 hover:bg-[#5B4638]/20 hover:shadow-[#5B4638]/20" />
          )}
        </div>
      </div> */}
    </div>
  );
};

export default PersonalInfoCard;